import axiosInstance from "../utils/axiosConfig";

const postExcluirEventoMotorista = async (dadosExclusao) => {
  const baseUrl = "https://workflow.grupocenze.com.br:38137/rest2/";
  const apiUrl = `${baseUrl}INT_APPMOTORISTA_EXCLUSAOPAPELETA`;

  try {
    const response = await axiosInstance.post(apiUrl, dadosExclusao, {
      headers: {
        "Content-Type": "application/json",
      },
      timeout: 10000, // Aumentar timeout para 10 segundos
    });

    return response.data;
  } catch (error) {
    console.error("Erro ao fazer a requisição:", error);

    throw new Error("Houve um problema ao excluir o evento do motorista.");
  }
};

export { postExcluirEventoMotorista };
